import { ROUTE_ACCESSIBILITY } from '../../../../helper/routeHelpers';
import { frontendURL } from '../../../../helper/URLHelper';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/message-hooks'),
      meta: {
        permissions: ['administrator'],
        onlyFor: ROUTE_ACCESSIBILITY.PHOENIX,
      },
      component: SettingsContent,
      props: {
        headerTitle: 'SIDEBAR.MESSAGE_HOOKS',
        icon: 'message-hooks',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'settings_message_hooks',
          component: Index,
          meta: {
            permissions: ['administrator'],
            onlyFor: ROUTE_ACCESSIBILITY.PHOENIX,
          },
        },
      ],
    },
  ],
};
